(function() { module.exports = this["wp"]["editPost"]; }());